module.exports = __webpack_public_path__ + "static/media/nouveau-groupe.6dc08538.png";